const DocumentType = Object.freeze({
  OFFER: 'offer',
  INVOICE: 'invoice',
  CLOSING_INVOICE: 'closingInvoice',
  DEPOSIT_INVOICE: 'depositInvoice',
  RECCURRING_INVOICE: 'recurringInvoice',
  RECCURRING_INVOICE_TEMPLATE: 'recurringInvoiceTemplate',
  DELIVERYNOTE: 'deliveryNote',
  ORDER: 'order',
  PROJECT: 'project',
  EXPENSE: 'expense',
  CANCELLATION: 'cancellation',
  REVENUE: 'revenue',
  MANUAL_CREDIT_NOTE: 'manualCreditNote',
  LETTER: 'letter',
  PURCHASE: 'purchase',
  DUNNING: 'dunning',
  PARTIAL_INVOICE: 'partialInvoice',
})

export default DocumentType
